// api/appApi.js
import axios from "axios";
import Cookies from "universal-cookie";
import { ROUTE_PATHS } from "../routes/routePath";
import { getCompanySyncClientId } from "./companySyncClient";

const cookies = new Cookies();
const BASE_URL = process.env.REACT_APP_API_URL;

export const appApi = axios.create({
  baseURL: `${BASE_URL}/api/`,
  responseType: "json",
  timeout: 30000, // Prevent hung requests from blocking UI loaders forever
  headers: {
    Accept: "application/json",
    "Content-Type": "application/json",
  },
});

// Request Interceptor
appApi.interceptors.request.use(
  (config) => {
    config.headers["Authorization"] = `Bearer ${cookies.get("token")}`;
    config.headers["X-Client-Id"] = getCompanySyncClientId();
    return config;
  },
  (error) => Promise.reject(error)
);

// Response Interceptor
appApi.interceptors.response.use(
  (response) => response,
  async (error) => {
    const status = error?.response?.status;
    const errorCode = error?.response?.data?.code;

    // Handle 401 - Session Expired
    if (status === 401) {
      cookies.remove("token", { path: '/' });
      cookies.remove("userId", { path: '/' });
      cookies.remove("userFullName", { path: '/' });
      cookies.remove("defaultcompany", { path: '/' });
      cookies.remove("defaulttenant", { path: '/' });
      cookies.remove("tenantEnabled", { path: '/' });

      const authPaths = [
        ROUTE_PATHS.LOGIN,
        ROUTE_PATHS.ADMIN_LOGIN,
        ROUTE_PATHS.TWO_FA,
        ROUTE_PATHS.FORGOT_PASSWORD,
        ROUTE_PATHS.RESET_PASSWORD
      ];

      if (!authPaths.includes(window.location.pathname)) {
        window.location.href = ROUTE_PATHS.LOGIN;
      }
      return Promise.reject(error);
    }

    // Handle 403 - Tenant Not Active
    if (status === 403 && errorCode === 'TENANT_NOT_ACTIVE') {
      cookies.set('tenantEnabled', false, { path: '/' });
      
      // Notify components
      window.dispatchEvent(new CustomEvent('tenantStatusChanged', { 
        detail: { tenantEnabled: false } 
      }));
      
      return Promise.reject(error);
    }

    return Promise.reject(error);
  }
);
